import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { editWorkspace, ownerFieldsMap, ROUTES, workspaceFieldsMap } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { ConfirmationPopupWithFormComponent } from 'libs/shared/ui-components/src/lib/confirmation-popup-with-form/confirmation-popup-with-form.component';
import { EditTicketComponent } from 'libs/shared/ui-components/src/lib/edit-ticket/edit-ticket.component';
import { ToastrService } from 'ngx-toastr';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-edit-workspace',
  templateUrl: './edit-workspace.component.html',
  styleUrls: ['./edit-workspace.component.scss']
})
export class EditWorkspaceComponent {
  workspaceId!: string | null;
  form!: string; 
  loaderView: boolean=false;
    selectedLoactions: string[] = [];
    selectedAcronyms: string[] = [];
    allowedDomains: string[] = [];
    codeTemplate: string[] = [];
    maxDate: string = '';
    noFutureDateValidator(control: AbstractControl): ValidationErrors | null {
      if (!control.value) return null; 
      const selected = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return selected > today ? { futureDate: true } : null;
    }
    workspaceDetails: FormGroup = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
      acronymLength: new FormControl('', [Validators.required, Validators.max(4)]),
      companyName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
      companyWebsiteLink: new FormControl('', [Validators.required, Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]),
      establishmentDate: new FormControl('', [Validators.required, this.noFutureDateValidator]),
    })
    workspaceOwnerDetails: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
    lastName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    empId: new FormControl('', Validators.required),
    phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]),
    empStatus: new FormControl('', Validators.required),
    empType: new FormControl('', Validators.required),
    designation: new FormControl('', Validators.required),
  })
    groupedConfigs: { [key: string]: any[] } = {};
    assetDetails: any;
    editFormData: any;
    payload: any;
    isLoading = false;
    canAddAcronym: boolean = false;
    statusList: string[] = [];
    typeList: string[] = [];
    designationList: string[] = [];
    isPasswordField: boolean = false;
    attributeIds: string[] = [];
    attributeMap: any ={};
    isLocationEditted = false;
    isDomainEditted = false;
    beforeLocationCount = 0;
    beforeDomainCount = 0;
    selectedValue: string = '';
    previewUrl: string | ArrayBuffer | null = null;
    ownerId: string | null = null;
    owner: any | null = null;
    hasWorkspaceOwner: boolean| null =null;
    buttonText:string = 'update';
    options: any[] = ['Standard Plan'];
    planId: string | null = null;
  
    constructor(
      private commonHttpService: CommonHttpService,
      private commonService: CommonService,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private toastrService: ToastrService,
      private cdr: ChangeDetectorRef,
      private dialog: Dialog,
      private fb: FormBuilder,
      private route: ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.loaderView=true;
    this.workspaceId = this.route.snapshot.paramMap.get('workspaceId');
    this.form = history.state.form;
    this.buttonText = this.form===editWorkspace.workspaceDetails ? 'Update' : 'Add';
    this.getWorkspaceDetails();
    this.getOwnerDetails();
    this.getPlans();
    this.assetDetails = {
      categories: [
        { name: 'Employee Type', displayName: 'Employee Type' },
        { name: 'Employee Status', displayName: 'Employee Status' },
        { name: 'Employee Designation', displayName: 'Employee Designation' }
      ],
      configs: [
        {
          category: 'Employee Type',
          displayName: 'empType',
          values: [],
          list: false
        },
        {
          category: 'Employee Status',
          displayName: 'empStatus',
          values: [],
          list: false
        },
        {
          category: 'Employee Designation',
          displayName: 'designation',
          values: [],
          list: true
        }
      ]
    };
    this.groupConfigsByCategory();
    this.commonHttpService.getUserAttributes(this.workspaceId).subscribe({
      next: (response: any) => {
        response.data.forEach((attr:any) => {
          this.attributeMap[attr.attributeName] = {
        id: attr.id,
        value: attr.attributeValue
      };
    })
    }
    });
  }
  getPlans() {
    this.loaderView = true;
    this.commonHttpService.getPlans().subscribe({
      next: (respone: any) => {
        this.options = respone.data.map((value: any) => ({
          name: value.name,
          id: value.id
        }))
        this.loaderView = false;
      }
    })
  }
  handleValue(event: any) {
    this.planId = event;
  }
  handleCancel() {
    this.router.navigate([ROUTES.WORKSPACE_DETAILS, this.workspaceId])
  }
  onInputChange(field: string, event: any) {
      if (workspaceFieldsMap[field]) {
        this.workspaceDetails.get(workspaceFieldsMap[field])?.setValue(event.target.value);
      }
    }
  // validation
  workspaceDetailsHasError(controlName: string) {
    const control = this.workspaceDetails.get(controlName);
    return control?.dirty && control?.errors;
  }
  workspaceOwnerHasError(controlName: string) {
    const control = this.workspaceOwnerDetails.get(controlName);
    return control?.dirty && control?.errors;
  }
  deleteListData(list: string, value: string) {
    if (list === 'location') {
      this.selectedLoactions.splice(this.selectedLoactions.findIndex((item) => item === value), 1);
    } else if (list === 'acronyms') {
      this.selectedAcronyms.splice(this.selectedAcronyms.findIndex((item) => item === value), 1);
    } else {
      this.allowedDomains.splice(this.allowedDomains.findIndex((item) => item === value), 1)
    }
  }
  getIdOfType(event: any) {
    this.workspaceOwnerDetails.controls['empType'].setValue(event);
  }
  getIdOfStatus(event: any) {
    this.workspaceOwnerDetails.controls['empStatus'].setValue(event);
  }
  getIdOfDesignation(event: any) {
    this.workspaceOwnerDetails.controls['designation'].setValue(event);
  }
  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
  getWorkspaceDetails(){
    this.loaderView = true;
    this.commonHttpService.getWorkspaceDetails(this.workspaceId!)
  .pipe(
    map((res: any) => res.data),
    tap((workspace) => {
      const date = new Date(workspace.establishmentDate);
      const formattedDate = date.toISOString().split('T')[0];

      this.loaderView = false;

      this.workspaceDetails.patchValue({
        name: workspace.name,
        acronymLength: workspace.acronyms[0]?.length ?? 0,
        companyName: workspace.companyName,
        companyWebsiteLink: workspace.companyWebsiteLink,
        establishmentDate: formattedDate,
      });

      this.selectedAcronyms = workspace.acronyms;
      this.allowedDomains = workspace.workspace_auth.allowedDomains;
      this.selectedLoactions = workspace.locations;

      this.beforeDomainCount = this.allowedDomains.length;
      this.beforeLocationCount = this.selectedLoactions.length;
      this.ownerId = workspace.workspaceOwner.id;
    })
  )
  .subscribe({
    next: (workspace) => {
      this.loaderView = false;
     },
    error: (err) => console.error('Error fetching workspace', err)
  });
  }
  getOwnerDetails() {
    this.loaderView=false;
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'empStatus').subscribe({
      next: (response: any) => this.statusList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'empType').subscribe({
      next: (response: any) => this.typeList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
    this.commonHttpService.getOwnerDetail(this.workspaceId!, 'designation').subscribe({
      next: (response: any) => this.designationList = response.data.map((attributes: any) => ({
        name: attributes.attributeValue,
        id: attributes.id
      }))
    })
  }
  addControl(val: string) {
      const validators = [Validators.required];
      if (val === 'acronym') {
        const length = +this.workspaceDetails.controls['acronymLength'].value;
        if (!length || length <= 0) {
          this.toastrService.error('Please set Acronym Length before adding acronyms');
          return;
        }
        validators.push(Validators.minLength(length), Validators.maxLength(length), Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/));
      } else if (val === 'domain') {
        validators.push(Validators.pattern(/^\S+\.(com|in|org)$/i));
      } else if (val === 'location') {
        validators.push(Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/));
      }
      const confirmationForm = new UntypedFormGroup({
        response: new UntypedFormControl('', validators)
      });
      const formData = {
        header: `Add ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
        description: `Please enter the ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
        image: 'cautionImage',
        form: { confirmationForm: confirmationForm },
        fields: [
          {
            field: 'text-field',
            controlName: 'response',
            placeholder: `Enter ${val === 'acronym' ? 'Asset Code Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
            label: `${val === 'acronym' ? 'Acronym' : val === 'location' ? 'Location' : 'Domain'}`,
            error: `${val === 'acronym' ? 'Invalid Length of Acronym' : val === 'location' ? 'Invalid Location' : 'Invalid Domain'}`,
            isAcronym: val === 'acronym'
          },
        ],
        secondaryBtn: 'Cancel',
        primaryBtn: 'Add',
      };
  
      const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
        panelClass: 'center-dialog-box',
        backdropClass: 'backdrop',
        disableClose: true,
        width: '50%',
        data: formData,
      });
  
      dialogRef.closed.subscribe((result: any) => {
        if (result) {
          if (val === 'acronym') {
            this.selectedAcronyms.push(result.response);
            this.canAddAcronym=true;
            this.codeTemplate = this.selectedAcronyms.map((acr) => `${acr}`+'-{financialYear}-${assetTypeCode}-${assetNumber}');
          } else if (val === 'location') {
            this.isLocationEditted = true;
            this.selectedLoactions.push(result.response);
          } else if (val === 'domain') {
            this.isDomainEditted = true;
            this.allowedDomains.push(result.response);
          }
        }
      });
    }

    groupConfigsByCategory() {
    this.groupedConfigs = {};
    this.assetDetails.configs.forEach((config: any) => {
      if (!this.groupedConfigs[config.category]) {
        this.groupedConfigs[config.category] = [];
      }
      this.groupedConfigs[config.category].push(config);
    });
  }

  getValuesDisplay(config: any): string {
    return config.values?.length ? config.values.join(', ') : 'Not added';
  }
  onEditConfig(categoryName: string, configIndex: number): void {
    const config = this.groupedConfigs[categoryName][configIndex];
    this.editFormData = {
      header: `Edit ${categoryName}`,
      description: `Modify values for ${categoryName}`,
      image: 'editImage',
      form: {
        confirmationForm: new FormGroup({
          property: new FormControl({ value: config.displayName, disabled: true }),
          value: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!\s)(?!.*\s$).+$/)]),
        }),
      },
      includeUnits: false,
      includeIsRequired: false,
      fields: [
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: `E.g. ${categoryName === 'Employee Type' ? 'On Probation' : categoryName === 'Employee Status' ? 'Active' : 'Intern'}`,
          label: 'Value(s)',
        },
      ],
      primaryBtn: 'Save',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: this.editFormData
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const newValues = result.value
          ? result.value.map((v: string) => v.trim()).filter((v: string) => v.length > 0)
          : [];

        this.groupedConfigs[categoryName][configIndex].values = newValues;
        const globalIndex = this.assetDetails.configs.findIndex(
          (c: any) => c.category === categoryName && c.displayName === config.displayName
        );

        if (globalIndex !== -1) {
          this.assetDetails.configs[globalIndex].values = newValues;
        }
        this.payload = {
          workspaceId: this.workspaceId,
          attributes: [
            ...Object.entries(this.groupedConfigs)
              .flatMap(([category, configs]) =>
                configs
                  .map(cfg => ({
                    attributeName: cfg.displayName,
                    attributeValues: [...this.attributeMap[cfg.category].value] 
                  }))
              )
          ]
        };
      }
    });
  }
  handleUpdate(){
    if(this.form===editWorkspace.workspaceDetails){
      this.codeTemplate = [`${this.selectedAcronyms[this.selectedAcronyms.length-1]}`+'-{financialYear}-${assetTypeCode}-${assetNumber}'];
      const dirtyValues = this.getDirtyValues(this.workspaceDetails);
      let payload: any = dirtyValues;
        if(dirtyValues.companyWebsiteLink){
          payload.companyWebsiteLink = this.workspaceDetails.controls['companyWebsiteLink'].value.startsWith('http') ? this.workspaceDetails.controls['companyWebsiteLink'].value : `https://${this.workspaceDetails.controls['companyWebsiteLink'].value}`;
        } 
        if(this.canAddAcronym){
          payload.acronyms = [this.selectedAcronyms[this.selectedAcronyms.length-1]];
          payload.codeTemplate = this.codeTemplate;
        }
        if(this.isLocationEditted){
          payload.location = this.selectedLoactions.slice(this.beforeLocationCount, this.selectedLoactions.length);
        }
        if(this.isDomainEditted){
          payload.allowedDomains = this.allowedDomains.slice(this.beforeDomainCount, this.allowedDomains.length);
        }
        this.commonHttpService.updateWorkspaceDetails(this.workspaceId!, payload).subscribe({
          next: (response:any) =>{
            this.toastrService.success('Workspace Details Updated Successfully!', '', {
              toastClass: 'toaster-wrapper',
            });
            this.router.navigate([ROUTES.WORKSPACE_DETAILS, this.workspaceId])
          },
           error: (err) => {
            this.isLoading = false;
            const errorList = err.error?.error?.errorList;
            const errorMessage = Array.isArray(errorList)
              ? errorList[0]?.msg || 'Error creating workspace'
              : errorList || 'Error creating workspace';
            this.toastrService.error(errorMessage, '', {
              toastClass: 'toaster-wrapper',
            });
          }
        })
    } else if(this.form===editWorkspace.userAttributes){
      this.payload = {
  workspaceId: this.workspaceId,
  attributes: [
    ...Object.entries(this.groupedConfigs)
      .flatMap(([category, configs]) =>
        configs
          .map(cfg => ({
            attributeName: cfg.displayName,
            attributeValues: cfg.values || []
          }))
      )
  ]
};
      this.commonHttpService.addUserAttribute(this.payload).subscribe({
        next: (response: any) => {
          this.attributeIds = response.data.map((attribute: any)=> attribute.id);
          this.toastrService.success('User Attributes Added Successfully!', '', {
            toastClass: 'toaster-wrapper',
          });
          this.router.navigate([ROUTES.WORKSPACE_DETAILS, this.workspaceId])
        },
        error: (err) => {
          const errorList = err.error?.error?.errorList;
          const errorMessage = Array.isArray(errorList)
            ? errorList[0]?.msg || 'Error Adding Attributes'
            : errorList || 'Error Adding Attribute';
          this.toastrService.error(errorMessage, '', {
            toastClass: 'toaster-wrapper',
          });
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      })
    } else if(this.form===editWorkspace.workspaceOwnerDetails){
      const payload = {
        "firstName": this.workspaceOwnerDetails.controls['firstName'].value,
        "lastName": this.workspaceOwnerDetails.controls['lastName'].value,
        "email": this.workspaceOwnerDetails.controls['email'].value,
        "employeeId": this.workspaceOwnerDetails.controls['empId'].value,
        "empStatus": this.workspaceOwnerDetails.controls['empStatus'].value,
        "empType": this.workspaceOwnerDetails.controls['empType'].value,
        "designation": this.workspaceOwnerDetails.controls['designation'].value,
        "phoneNumber": this.workspaceOwnerDetails.controls['phoneNumber'].value,
        "isUserOnboarded": true,
        "roleId": 'WORKSPACE-OWNER'
      }
        this.loaderView=true;
        this.commonHttpService.sendCreateWorkspaceOwnerDetails(payload, this.workspaceId!).subscribe({
          next: (response: any) => {
            this.owner = response.data.createdUser;
            this.ownerId = response.data.createdUser.id;
            this.hasWorkspaceOwner=true;
            this.toastrService.success('Workspace Owner Added Successfully!', '', {
              toastClass: 'toaster-wrapper',
            });
            this.loaderView = false;
            this.router.navigate([ROUTES.WORKSPACE_DETAILS, this.workspaceId])
          },
          error: (err) => {
            const errorList = err.error?.error?.errorList;
            const errorMessage = Array.isArray(errorList)
              ? errorList[0]?.msg || 'Error Adding Workspace Owner Details'
              : errorList || 'Error Adding Workspace Owner Details';
            this.toastrService.error(errorMessage, '', {
              toastClass: 'toaster-wrapper',
            });
            this.loaderView = false;
          },
          complete: () => {
            this.loaderView = false;
          }
        })
    } else if(this.form===editWorkspace.plan){
      const payload = {
            workspaceId: this.workspaceId,
            planId: this.planId,
            purchasedBy: this.ownerId
          }
          this.loaderView = true;
          this.commonHttpService.sendWorspaceDetails(payload).subscribe({
            next: (response: any) => {
              this.toastrService.success('Plan Activated Successfully!', '', {
                toastClass: 'toaster-wrapper',
              });
              this.loaderView = false;
               this.router.navigate([ROUTES.WORKSPACE_DETAILS, this.workspaceId])
            },
            error: (err) => {
              const errorList = err.error?.error?.errorList;
              const errorMessage = Array.isArray(errorList)
                ? errorList[0]?.msg || 'Error Activating Plan'
                : errorList || 'Error Activating Plan';
              this.toastrService.error(errorMessage, '', {
                toastClass: 'toaster-wrapper',
              });
              this.loaderView = false;
            }
          })
    }
  }
  getDirtyValues(formGroup: FormGroup): any {
  const dirtyValues: any = {};
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (control?.dirty) {
      dirtyValues[key] = control.value;
    }
  });
  return dirtyValues;
}
getDisabledStatus(){
  if(this.form===editWorkspace.workspaceDetails) return (!this.isLocationEditted && !this.isDomainEditted && !this.canAddAcronym && (this.workspaceDetails.invalid || !this.workspaceDetails.dirty));
  if(this.form===editWorkspace.workspaceOwnerDetails) return (this.workspaceOwnerDetails.invalid || !this.workspaceOwnerDetails.dirty);
  return false;
}
}
